import React from 'react';
import { CustomModal } from 'components';
import { ShareEstimateSection } from './ShareEstimateSection';
import { CrossIconvector } from 'assets/icons';

interface ShareEstimateModalProps {
  isOpen: boolean;
  onClose: () => void;
  estimateId: string;
  resetEstimatesQuery: () => void;
}

export const ShareEstimateModal: React.FC<ShareEstimateModalProps> = ({
  isOpen,
  onClose,
  estimateId,
  resetEstimatesQuery
}) => {
  return (
    <CustomModal open={isOpen} closeModal={onClose} className="w-full max-w-md">
      <div className="relative p-4">
        <div
          onClick={onClose}
          className="absolute top-4 right-4 cursor-pointer text-gray-400 hover:text-gray-500"
          aria-label="Close modal">
          <CrossIconvector className="h-6 w-6" />
        </div>
        <h2 className="mb-4 pr-8 text-xl font-semibold">Share Estimate</h2>
        <ShareEstimateSection estimateId={estimateId} resetEstimatesQuery={resetEstimatesQuery} />
      </div>
    </CustomModal>
  );
};
